// extracted by mini-css-extract-plugin
module.exports = {"section1":"style_section1__wIegF","section2":"style_section2__KxZzV","section2-last":"style_section2-last__344XX"};